import { z } from 'zod';
import { requiredFieldError } from '../../helper';
import { EnterpriseStructure } from '../../types';
import { smeDirectorBasic } from './ownershipDetail';

const directorsArray = z
  .array(smeDirectorBasic)
  .min(1)
  .refine(arr => arr.some(director => director?.isGuarantor), {
    message: requiredFieldError('Guarantor'),
  });

export const partnershipGuarantors = z.object({
  structure: z.literal(EnterpriseStructure.Partnership),
  partnership: z.object({
    directors: directorsArray,
  }),
});

export const proprietaryLimitedCompanyGuarantors = z.object({
  structure: z.literal(EnterpriseStructure.ProprietaryLimitedCompany),
  proprietaryLimitedCompany: z.object({
    directors: directorsArray,
  }),
});

export const trustGuarantors = z.object({
  structure: z.literal(EnterpriseStructure.Trust),
  trust: z.object({
    directors: directorsArray,
  }),
});

export const guarantors = z.discriminatedUnion('structure', [
  partnershipGuarantors,
  proprietaryLimitedCompanyGuarantors,
  trustGuarantors,
]);

export type GuarantorType = z.infer<typeof guarantors>;
